import React from 'react';

import type { LegislativeBody } from '../../../shared/types';
import { Member } from '../Member';

type MemberListProps = {
	legislativeBody: LegislativeBody;
	testId: string;
	viewMoreTrigger?: React.ReactNode;
};

export const MemberList: React.FC<MemberListProps> = ({ legislativeBody, testId, viewMoreTrigger }) => {
	const { viewMoreCount, displayedDMs } = legislativeBody;
	return (
		<div className="mt-6 flex flex-col items-start gap-4" data-testid={testId}>
			{displayedDMs.map((dm) => (
				<Member key={dm.id} {...dm} />
			))}
			{viewMoreCount > 0 && viewMoreTrigger}
		</div>
	);
};
